// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8168 ? "react-leaflet" : chunkId) + "." + {"1363":"3b3f76da1fe98189","5548":"482d1462bd20eb02","8168":"acf9be233c45c98f"}[chunkId] + ".js";
};